import BaseMessage from '../BaseMessage';

class Ping extends BaseMessage {
  constructor() {
    super();
    this.method = 'blade.ping';
    this.buildRequest({
      method: this.method,
      params: {}
    });
  }

}

export { Ping };